export const getWcoXmlWebAnalytics = state => state.wcoxmlweb.companyWcoXmlData;
export const getExportingStatus = state => state.wcoxmlweb.exporting;
export const getLoadingStatus = state => state.wcoxmlweb.loading;
export const getErrorStatus = state => state.wcoxmlweb.error;

// fetch company wcoxml web details
// export wco_xml_web_config
